
import {
  Component,
  Vue
} from 'vue-property-decorator'
import {
  BreadcrumbModule
} from '@/store/modules/BreadcrumbModule'
import lazyLoad from '@/components/LazyLoad'

@Component({
  name: 'MasterData'
})
export default class MasterData extends Vue {
    protected type: any = null
    protected showComponent: any = false

    /* created () {
      this.boot()
    } */

    get component () {
      if (this.type === 'Participant') {
        return () => lazyLoad(import('./Participant.vue'))
      }

      if (this.type === 'Vehicle') {
        return () => lazyLoad(import('./Vehicle.vue'))
      }
    }

    public show () {
      BreadcrumbModule.setBreadcrumb(this.$route)
      this.showComponent = true
      this.type = 'Participant'
    }

    protected hide () {
      this.showComponent = false
    }
}

